/**
 * @generated SignedSource<<17da3b91276a3fd23bf424710b37bb8f>>
 * @relayHash cccfc99d1ade2aca714f0242a442c8f6
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cccfc99d1ade2aca714f0242a442c8f6

import { ConcreteRequest } from 'relay-runtime';
export type DeMedicationType = "FREE_TEXT_MEDICATION" | "PREPARATION" | "SUBSTANCE";
export type MedicationUnit = "GTT" | "IU" | "MG" | "ML" | "PC" | "PRN" | "PUFF";
export type De_createRecommendedMedicationInput = {
  medicationId: string;
  patientId: string;
  progressNoteId: string;
};
export type deCreateRecommendedMedicationMutation$variables = {
  connections: ReadonlyArray<string>;
  input: De_createRecommendedMedicationInput;
};
export type deCreateRecommendedMedicationMutation$data = {
  readonly deCreateRecommendedMedication: {
    readonly de_RecommendedMedication: {
      readonly id: string;
      readonly medication: {
        readonly __typename: "de_Medication";
        readonly composition: string | null;
        readonly createdAt: string;
        readonly createdBy: string;
        readonly endDate: any | null;
        readonly eveningDosage: number;
        readonly id: string;
        readonly internalNotes: string | null;
        readonly isPermanentPrescription: boolean;
        readonly isPrescriptionRequired: boolean;
        readonly morningDosage: number;
        readonly name: string;
        readonly nightDosage: number;
        readonly noonDosage: number;
        readonly numberOfPackages: number;
        readonly patientId: string;
        readonly pharmaceuticalCentralNumber: string | null;
        readonly refuseSubstitutes: boolean;
        readonly startDate: any | null;
        readonly type: DeMedicationType;
        readonly unit: MedicationUnit;
        readonly updatedAt: string | null;
        readonly updatedBy: string | null;
        readonly usageInstructions: string | null;
      };
      readonly medicationId: number;
      readonly patientId: string;
      readonly progressNoteId: number;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type deCreateRecommendedMedicationMutation = {
  response: deCreateRecommendedMedicationMutation$data;
  variables: deCreateRecommendedMedicationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "patientId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "de_RecommendedMedication",
  "kind": "LinkedField",
  "name": "de_RecommendedMedication",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "de_Medication",
      "kind": "LinkedField",
      "name": "medication",
      "plural": false,
      "selections": [
        (v3/*:: as any*/),
        (v4/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "refuseSubstitutes",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "numberOfPackages",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "eveningDosage",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "internalNotes",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isPrescriptionRequired",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "morningDosage",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "nightDosage",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "noonDosage",
          "storageKey": null
        },
        (v5/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pharmaceuticalCentralNumber",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unit",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "usageInstructions",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "composition",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedBy",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdBy",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isPermanentPrescription",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v4/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "medicationId",
      "storageKey": null
    },
    (v5/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "progressNoteId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "deCreateRecommendedMedicationMutation",
    "selections": [
      {
        "alias": "deCreateRecommendedMedication",
        "args": (v2/*:: as any*/),
        "concreteType": "De_createRecommendedMedicationPayload",
        "kind": "LinkedField",
        "name": "de_createRecommendedMedication",
        "plural": false,
        "selections": [
          (v6/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v7/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "deCreateRecommendedMedicationMutation",
    "selections": [
      {
        "alias": "deCreateRecommendedMedication",
        "args": (v2/*:: as any*/),
        "concreteType": "De_createRecommendedMedicationPayload",
        "kind": "LinkedField",
        "name": "de_createRecommendedMedication",
        "plural": false,
        "selections": [
          (v6/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "prependNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "de_RecommendedMedication",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "de_ProgressNoteEdge"
              }
            ]
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/),
              (v7/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "cccfc99d1ade2aca714f0242a442c8f6",
    "metadata": {},
    "name": "deCreateRecommendedMedicationMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "b37fda2a5c791bcbc119a9feda38916b";

export default node;
